import { useEffect, useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';

let opener = null;

/**
 * Custom on-brand confirmation dialog. Usage:
 *   const ok = await confirmDialog({ title, message, confirmLabel, danger });
 * Falls back to native confirm if the host isn't mounted.
 */
export function confirmDialog(opts = {}) {
  return new Promise((resolve) => {
    if (!opener) {
      // eslint-disable-next-line no-alert
      resolve(window.confirm(opts.message || 'Are you sure?'));
      return;
    }
    opener({ ...opts, resolve });
  });
}

function ConfirmDialog() {
  const [state, setState] = useState(null);

  useEffect(() => {
    opener = (s) => setState(s);
    return () => { opener = null; };
  }, []);

  if (!state) return null;

  const close = (value) => {
    state.resolve(value);
    setState(null);
  };

  const {
    title = 'Are you sure?',
    message = '',
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    danger = true,
  } = state;

  return (
    <div className="confirm-overlay" onClick={() => close(false)}>
      <div className="confirm-modal panel" onClick={(e) => e.stopPropagation()} role="alertdialog" aria-modal="true">
        <button className="confirm-close" onClick={() => close(false)} aria-label="Close"><X size={16} /></button>
        <div className={`confirm-icon ${danger ? 'danger' : ''}`}><AlertTriangle size={22} /></div>
        <h3 className="confirm-title">{title}</h3>
        {message && <p className="confirm-message">{message}</p>}
        <div className="confirm-actions">
          <button className="secondary-button" onClick={() => close(false)}>{cancelLabel}</button>
          <button className={danger ? 'confirm-danger' : 'primary-button'} onClick={() => close(true)}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
